import Ratings from '@components/common/ratings'
import BookTrialClassContainer from '@containers/book-trial-class/book-trial-class-container'
import { GEO_CONTENT, LANGUAGES } from '@lib/constants/geo-lp'
import dynamic from 'next/dynamic'

const DynamicCodingalLogo = dynamic(() =>
  import('@components/landing-page/geo-landing-page/first-fold/codingal-logo')
)

const DynamicCodingalPartnerLogo = dynamic(() =>
  import(
    '@components/landing-page/geo-landing-page/first-fold/codingal-parter-logo'
  )
)

const { ENGLISH } = LANGUAGES

type FirstFoldProps = {
  title: JSX.Element
  subTitle?: string
  gradeText?: string
  eligibleGroup: JSX.Element[]
  countryCode?: string
  cta?: string
  partnerLogo?: string
  logoImageProperties?: {
    width?: number
    height?: number
    alt?: string
  }
  partnerLink?: string
  slug?: string
}

const FirstFold = ({
  title,
  eligibleGroup,
  countryCode,
  subTitle,
  cta,
  gradeText,
  partnerLogo,
  logoImageProperties = {
    height: 40,
    width: 115,
    alt: 'Partner logo',
  },
  partnerLink,
  slug,
}: FirstFoldProps) => {
  const {
    heroFold: { form },
  } = GEO_CONTENT[ENGLISH]

  return (
    <div
      className="relative lg:py-10"
      style={{
        background:
          'linear-gradient(0.94deg, rgba(191, 50, 64, 0.05) -9.25%, rgba(183, 50, 82, 0.05) -0.72%, rgba(126, 54, 217, 0.05) 104.12%), #FFFFFF',
      }}
    >
      {!partnerLogo && <DynamicCodingalLogo />}

      {partnerLogo && (
        <DynamicCodingalPartnerLogo
          partnerLogo={partnerLogo}
          logoImageProperties={logoImageProperties}
          partnerLink={partnerLink}
        />
      )}

      <div className="z-10 relative flex flex-col items-center justify-center space-y-10 px-5 lg:px-24 lg:flex-row lg:space-x-24 mt-10 pb-5">
        <div className="flex flex-col w-full md:px-2 space-y-8 md:w-148 lg:px-0">
          <div className="flex flex-col items-center space-y-5 lg:items-start">
            <div className="hidden md:block">
              <Ratings isDarkText />
            </div>
            <h1 className="md:pt-3 mt-0 text-2xl leading-none text-center font-600 md:text-5xl lg:text-left md:mt-10 lg:mt-12">
              {title}
            </h1>
            <p className="text-xl">{gradeText ? gradeText : 'Grade 1-12'}</p>
            {subTitle && (
              <p className="py-2 text-center lg:text-left text-xl">
                {subTitle}
              </p>
            )}
            <div className="gap-2 flex md:flex-wrap justify-center">
              {eligibleGroup.map((list, index) => (
                <span
                  key={index}
                  className="inline-block px-1 py-1 rounded-md text-left text-grey"
                  style={{
                    background: '#E0E3FD',
                  }}
                >
                  {list}{' '}
                </span>
              ))}
            </div>
          </div>
        </div>
        <div className="z-10 pb-6 mt-4 lg:mt-0">
          <BookTrialClassContainer
            countryCode={countryCode}
            shouldHaveFormShadow={true}
            phoneFieldLabel={form.phoneFieldLabel}
            cta={cta || form.ctaText}
            gradeFieldPlaceholder={form.gradeFieldPlaceholder}
            termsAndConditions={form.termsAndConditions}
            slug={slug}
          />
        </div>
      </div>
    </div>
  )
}
export default FirstFold
